import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Moved to `panel-preferences/create`; also keeps `add-preference` from being read as an id.
export const Route = createFileRoute('/_authenticated/settings/organization/pcb/add-preference')({
    // Only redirects: `create` checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: () => {
        throw redirect({ to: '/settings/organization/pcb/panel-preferences/create', search: true, replace: true });
    },
});
